/**
 * Bridge: conecta MUI ThemeProvider ao effectiveTheme do ThemeContext IAT.
 * Renderiza o tema MUI correto (light/dark) sempre que o usuário troca o modo.
 */
import React, { useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { useTheme } from '../contexts/ThemeContext';
import { buildIATMuiTheme } from './muiTheme';

export function MuiThemeBridge({ children }) {
  const { effectiveTheme } = useTheme();
  const theme = useMemo(() => buildIATMuiTheme(effectiveTheme), [effectiveTheme]);
  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
